import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  onClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
};

export const Forgot: FC<Props> = ({ onClick }) => (
  <div className="modal__forgot__container">
    <button
      type="button"
      className="modal__forgot"
      onClick={onClick}
      data-test-id="show-forgot-password"
    >
      <FormattedMessage id="login/components/forgot/Forgot.tsx/1" />
    </button>
  </div>
);
